import { cn } from "../../lib/utils";
import type { Owner } from "../../data/types";

interface OwnerTagProps {
  owner: Owner;
  className?: string;
}

const ownerCfg: Record<Owner, { initials: string; bg: string; text: string; ring: string }> = {
  Joel: { initials: "JR", bg: "bg-amber-500/10", text: "text-amber-300", ring: "ring-amber-500/15" },
  Albert: { initials: "AO", bg: "bg-sky-500/10", text: "text-sky-300", ring: "ring-sky-500/15" },
  "AI Wave": { initials: "AI", bg: "bg-emerald-500/10", text: "text-emerald-300", ring: "ring-emerald-500/15" },
  Joint: { initials: "J+A", bg: "bg-purple-500/10", text: "text-purple-300", ring: "ring-purple-500/15" },
};

export function OwnerTag({ owner, className }: OwnerTagProps) {
  const c = ownerCfg[owner];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-[7px] py-[1px] text-[10px] leading-[14px] font-semibold tracking-[0.04em] uppercase ring-1 ring-inset",
        c.bg, c.text, c.ring, className
      )}
      title={owner}
    >
      {c.initials}
    </span>
  );
}
